<template>
    <div class="xcard" style="margin-bottom:16px">
        <p class="text-primary"> <b> <span class="text-danger">*</span> Cargos y sedes de este usuario:.</b> </p>
        <div class="row">
            <div class="col-sm-6">
                <multiselect class="form-control" v-model="modelo.idsede" :options="sedes" track-by="id" label="nombre" :searchable="false" :close-on-select="true" :show-labels="false" placeholder="Seleccione la sede..."></multiselect>
            </div>
            <div class="col-sm-5">
                <multiselect class="form-control" v-model="modelo.idcargo" :options="cargos" track-by="id" label="nombre" :searchable="false" :close-on-select="true" :show-labels="false" placeholder="Seleccione el cargo..."></multiselect>
            </div>
            <div class="col">
                <button @click="asignar" type="button" class="btn btn-sm btn-azul" :disabled="asignando">Asignar</button>
            </div>
        </div>

        <multiselect :disabled="quitando" class="form-control" v-model="asignados" :options="asignados" track-by="idsede" label="nombre" 
            :multiple="true" :searchable="false" :close-on-select="true" :show-labels="false" :allow-empty="false"
            @remove="onRemove" 
            placeholder="Cargos y sedes asignados.">
        
            <template slot="tag" slot-scope="{ option, remove }">
                <div>
                <span class="custom__tag">
                    <span class="custom__remove" @click="remove(option)">❌</span>
                    <span> {{option.nombre}} </span>
                </span>
                </div>
            </template>
        
        </multiselect>
    </div>
</template>

<script>
import gql from 'graphql-tag'
import {parseJsonError,error2} from '@/components/Utils.js'
export default {
    props:{ model:Array,default:{type:Array,required:false,default:null} },
    data(){
        return{
            asignando: false,
            quitando: false,
            sedes: [],
            cargos: [],
            asignados: [],
            asig: {},
            modelo: {
                idsede: null,
                idcargo: null,
            }
        }
    },
    watch:{
        asignados: {
            deep: true,
            handler(){
                var vue = this;
                vue.model.splice(0,vue.model.length)
                vue.asignados.forEach(function(e){
                    vue.model.push( {idcargo:e.idcargo,idsede:e.idsede,desde:e.desde } );
                });
            }
        },
        'default': function(a){
            if( a == null ) return;
            var vue = this;
            a.forEach(function(e){
                vue.modelo = e;
                vue.cargar();
            });
            this.modelo.idsede = null;
            this.modelo.idcargo = null;
        },
    },
    methods:{
        async getSedes() {
            let rolid = this.$store.state.CARGO.id;
            if(rolid != 1){
                let d = this.$store.state.CARGOS;
                const sedes = [];
                d.forEach(x=>{
                    sedes.push({id:x.sede.id, nombre:x.sede.nombre})
                })
                this.sedes = sedes;
                return;
            }
            
            var vue = this;
            var sql = gql`query{getSedes{id,nombre}}`;
            await this.$apollo.query({
            query: sql,
            }).then((data) => {
                var dat = data.data.getSedes;
                var thiz = this;
                dat = dat.filter( function(e){
                    var permitido = thiz.$store.state.CARGOS.find( x => x.idsede == e.id ); // mostrar solo las sedes permitidas
                    return permitido != null;
                });
                vue.sedes = dat;
            }).catch((error) => {
                window.console.error(error)
                this.$notify( parseJsonError( error,'getSedes' ) )
            })
        },
        async getCargos() {
            var vue = this;
            var sql = gql`query{getCargos{id,nombre}}`;
            await this.$apollo.query({
            query: sql,
            }).then((data) => {
                var dat = data.data.getCargos;
                var jerarquia = this.$store.state.CARGO.id;
                var mkt = jerarquia == 11 || jerarquia == 11 || jerarquia == 11 ;
                window.console.log( dat )
                dat = dat.filter(function(e){ 
                    if( jerarquia == 8 ){ //enc sistemas registra academicos, hasta asesor ejecutivos
                        if( e.id == 6 || e.id == 7 || e.id == 15 || e.id == 25 ) return true;
                        else return (e.nombre!="Master" && e.id >= jerarquia && e.id <=13)    
                    }
                    else if( mkt ){
                        return (e.nombre!="Master" && (e.id >= jerarquia && e.id <=13)) 
                    }else{
                        return (e.nombre!="Master" && e.id >= jerarquia)    
                    }
                }) // excluir a master
                vue.cargos = dat;
            }).catch((error) => {
                window.console.error(error)
                this.$notify( parseJsonError( error,'getCargos' ) )
            })
        },
        onRemove( removedOption ){
            var xu = sessionStorage.xxusuario;
            if( xu == null ) return;
            var iduser = JSON.parse(xu).id;
            var input = {};
            input.idusuario = iduser;
            input.idcargo = removedOption.idcargo;
            input.idsede = removedOption.idsede;
            input.desde = removedOption.desde;
            //this.deleteCargo( input );
        },
        cargar(){
            if( this.modelo.idsede != null && this.modelo.idcargo != null ){
                var existe = this.asignados.find(x => (x.idsede==this.modelo.idsede.id && x.idcargo==this.modelo.idcargo.id) );
                if( !existe ) {
                    var nom = this.modelo.idsede.nombre + ' - '+this.modelo.idcargo.nombre;
                    this.asignados.push( {idcargo:this.modelo.idcargo.id,idsede:this.modelo.idsede.id,nombre:nom,desde:this.modelo.desde} );
                    
                }
            }
        },
        asignar(){
            if( this.modelo.idsede != null && this.modelo.idcargo != null ){
                //var existe = this.asignados.find(x => (x.idsede==this.modelo.idsede.id && x.idcargo==this.modelo.idcargo.id) );
                var existe = this.asignados.find(x => (x.idsede==this.modelo.idsede.id ) ); // no mas de un cargo por sede
                if( !existe ) {
                    var nom = this.modelo.idsede.nombre + ' - '+this.modelo.idcargo.nombre;
                    this.asignados.push( {idcargo:this.modelo.idcargo.id,idsede:this.modelo.idsede.id,nombre:nom,desde:this.modelo.desde} );

                }else{
                    this.$notify( error2( 'No Valido','No se permite mas de un cargo por sede.',4000 ) )
                }
            }
        },
    },
    mounted(){
        this.getSedes();
        this.getCargos();
    }
}
</script>